import { Typography } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { useTranslation } from 'react-i18next';

import { Spacing, SpacingUnit } from 'components/ui';
import { FieldsCatalogControllerStore } from 'stores/local/forms/EditFormStore/FieldsCatalogControllerStore';
import { translateApiValue } from 'utils/translateApiValue';

import { FieldsChunk } from '../../utils';

import { CatalogItemCheckbox } from './CatalogItemCheckbox';

type Props = {
  fieldsChunk: FieldsChunk;
  showGroupTitles?: boolean;
  indexInColumn: number;
  catalogDrawerControllerStore: FieldsCatalogControllerStore;
};

const FieldsChunkView: React.FC<Props> = ({
  catalogDrawerControllerStore,
  fieldsChunk,
  showGroupTitles,
  indexInColumn,
}: Props) => {
  const { t } = useTranslation();

  /**
   * Показываем заголовок, если
   * - извне передано свойство, что заголовок нужно показывать
   * - если это первый чанк в категории
   * - ИЛИ если это первый чанк в колонке, например, при переносе колонки
   */
  const showTitle =
    showGroupTitles &&
    (fieldsChunk.indexInCategory === 0 || indexInColumn === 0);

  /**
   * Этот чанк — продолжение списка полей из колонки слева
   */
  const isContinue = fieldsChunk.indexInCategory !== 0 && indexInColumn === 0;

  return (
    <Spacing
      key={`${fieldsChunk.category}-${fieldsChunk.indexInCategory}`}
      spacing={SpacingUnit.unit3}
    >
      {showTitle && (
        <>
          <Typography.Title level={4}>
            {translateApiValue(fieldsChunk.category)}
          </Typography.Title>
          {isContinue && (
            <Typography.Text type="secondary">
              {t('editForm.continuation')}
            </Typography.Text>
          )}
        </>
      )}

      <Spacing spacing={SpacingUnit.unit3}>
        {fieldsChunk.chunks.map((item) => (
          <CatalogItemCheckbox
            store={catalogDrawerControllerStore}
            entity={item}
            key={item.id}
          />
        ))}
      </Spacing>
    </Spacing>
  );
};

export default observer(FieldsChunkView);
